import { Component } from '@angular/core';
import { AuthenticationService } from '@core/authentication.service';
import { UserService } from '@core/user.service';
import { Quest } from '@models/quest';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'zbp-student-quest-complete',
  templateUrl: './student-quest-complete.component.html',
  styleUrls: ['./student-quest-complete.component.scss'],
  standalone: false
})
export class StudentQuestCompleteComponent {
  currentQuest: Quest;
  quests: Quest[];
  private isSaving: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private userService: UserService) {
  }

  initialize(quests: Quest[]): void {
    if (quests.length > 0) {
      this.quests = quests;
      this.loadNextQuest(this.quests[0]);
    } else {
      this.close();
    }
  }

  loadNextQuest(quest: Quest) {
    this.currentQuest = new Quest(quest);
    this.currentQuest.description = this.currentQuest.description.replace(/__/g, '');
  }

  confirm() {
    // Block the profile update if save is in progress.
    if (this.currentQuest && !this.isSaving) {
      const { recentlyCompletedQuestIds } = this.userService.user.profileDetail;
      this.isSaving = true;

      this.userService.updateRecentlyCompletedQuests(recentlyCompletedQuestIds, this.currentQuest).subscribe((res) => {
        this.isSaving = false;
        if (res.success) {
          let questIndex = this.quests.findIndex(q => q.questId === this.currentQuest.questId);
          questIndex++;
          if (questIndex < this.quests.length) {
            this.loadNextQuest(this.quests[questIndex]);
          } else {
            this.close();
          }
        } else {
          console.error(res.messages);
          this.toastr.error('There was an error updating your profile. Please tell your teacher.');
        }
      }, (err) => {
        this.isSaving = false;
        console.error(err);
        this.toastr.error('There was an error updating your profile. Please tell your teacher.');
      });
    } else if (!this.isSaving) {
      this.close();
    }
  }

  close() {
    this.activeModal.close(this.currentQuest);
  }
}
